import { useContext, useRef, useState } from "react";
import { CustomModal } from "../../layouts/customModal";
import { CircleCaution, Trash } from "../../layouts/icons";
import { Dialog } from "@headlessui/react";
import { Badge, Button } from "flowbite-react";
import { StatusContext } from "../../context/statusProvider";
import { DeleteCampaign } from "../../services/creditBonus/creditBonusActions";
import { ResponseContext } from "../../context/responseProvider";
import { cpCampaign } from "../../services/creditBonus/creditBonusCpActions";

export const DeleteCbCampaign = ({ data }) => {
  const modalRef = useRef(null);
  const openRef = useRef(null);
  const { handleApi } = useContext(StatusContext);
  const [isLoading, setIsLoading] = useState(false);
  const { getResponse, setResponse } = useContext(ResponseContext);

  const handleDelete = async () => {
    try {
      await cpCampaign(
        "delete_campaign",
        {
          promo_type: data.promo_type,
        },
        data.id,
        localStorage.getItem("userEmail"),
        "cb_cp_delete_campaign",
      );

      DeleteCampaign({
        campaignId: data.id,
        email: localStorage.getItem("userEmail"),
        setIsLoading,
        setResponse,
        onSuccess: () => {
          handleApi();
          handleClose();
        },
      });
    } catch (err) {
      console.error("Delete failed:", err);
      setResponse("delete_campaign", false, err.message);
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    modalRef.current();
  };

  return (
    <CustomModal
      btnText={"Delete"}
      modalRef={modalRef}
      openRef={openRef}
      customBtn={
        <div id="modalBtn">
          <Button
            onClick={() => {
              openRef.current();
            }}
          >
            <Trash />
            {"Delete"}
          </Button>
        </div>
      }
    >
      <Dialog.Title
        as="h3"
        className="text-lg font-medium leading-6 text-gray-900 inline-flex"
      >
        <strong className="flex align-middle">
          <CircleCaution />
          Delete Campaign
        </strong>
      </Dialog.Title>

      <div className="mt-2">
        <p className="text-sm text-gray-500">
          <span>
            Are you sure you want to delete{" "}
            <strong className="break-words">{data.promo_name}</strong> ? This
            action cannot be undone.
          </span>
        </p>
      </div>

      <div className="mt-2">
        {getResponse("delete_campaign")?.status === false && (
          <Badge color="failure">
            {getResponse("delete_campaign")?.message}
          </Badge>
        )}
      </div>

      <div className="mt-4 inline-flex gap-3">
        <button className="text-sm font-semibold" onClick={handleClose}>
          Cancel
        </button>
        <button
          type="button"
          className="inline-flex justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium  focus:outline-none text-red-600 bg-red-100"
          onClick={handleDelete}
          disabled={isLoading}
        >
          Confirm
        </button>
      </div>
    </CustomModal>
  );
};
